export const applyStyles = (css, replace = false) => {
    // const style = document.createElement('style');
    // style.textContent = css.cssText;
    // document.head.appendChild(style);

    const cssText = replace
        ? css.cssText.replace(/:host\s*{/g, ':root {')
        : css.cssText;

    const styleSheet = new CSSStyleSheet();
    styleSheet.replaceSync(cssText);
    document.adoptedStyleSheets = [...document.adoptedStyleSheets, styleSheet];
}